module.exports = __webpack_public_path__ + "img/reviewer-B.b77518e5.png";